// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"883":"component---src-pages-404-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"883":"56fda3bf5b19e3c6b16e","989":"1636ce31531785ff4b36"}[chunkId] + ".js";
};